const STORAGE_KEY = 'uncollectedRentNotifySent:v1';

function memoryStorage() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage;
}

function uncollectedNotifyDayKey(now = new Date()) {
  return now.toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
}

function uncollectedNotifyLeaseKey(lease) {
  if (lease == null) return '';
  if (lease.leaseId != null && lease.leaseId !== '') {
    return `lease:${lease.leaseId}`;
  }
  if (lease.propertyId != null && lease.propertyId !== '') {
    return `property:${lease.propertyId}`;
  }
  if (lease.peopleId != null && lease.peopleId !== '') {
    return `people:${lease.peopleId}`;
  }
  return '';
}

function readStore(storage) {
  if (!storage || typeof storage.getItem !== 'function') {
    return { date: '', ids: [] };
  }
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return { date: '', ids: [] };
    const parsed = JSON.parse(raw);
    return {
      date: String(parsed?.date || ''),
      ids: Array.isArray(parsed?.ids) ? parsed.ids.map(String) : [],
    };
  } catch {
    return { date: '', ids: [] };
  }
}

function writeStore(storage, date, ids) {
  if (!storage || typeof storage.setItem !== 'function') return;
  storage.setItem(
    STORAGE_KEY,
    JSON.stringify({ date, ids: [...new Set(ids)] }),
  );
}

function resolveOpts(opts = {}) {
  return {
    storage: opts.storage ?? memoryStorage(),
    now: opts.now ?? new Date(),
  };
}

function wasUncollectedNotifySentToday(lease, opts) {
  const id = uncollectedNotifyLeaseKey(lease);
  if (!id) return false;
  const { storage, now } = resolveOpts(opts);
  const store = readStore(storage);
  if (store.date !== uncollectedNotifyDayKey(now)) return false;
  return store.ids.includes(id);
}

function markUncollectedNotifySentToday(lease, opts) {
  const id = uncollectedNotifyLeaseKey(lease);
  if (!id) return;
  const { storage, now } = resolveOpts(opts);
  if (!storage) return;
  const today = uncollectedNotifyDayKey(now);
  const store = readStore(storage);
  const ids = store.date === today ? store.ids.slice() : [];
  if (!ids.includes(id)) ids.push(id);
  writeStore(storage, today, ids);
}

function filterUncollectedNotifyQueue(queue, opts) {
  return (queue || []).filter(
    (lease) => !wasUncollectedNotifySentToday(lease, opts),
  );
}

const inFlight = new Set();

function beginUncollectedNotifySend(lease) {
  const id = uncollectedNotifyLeaseKey(lease);
  if (!id) return true;
  if (inFlight.has(id)) return false;
  inFlight.add(id);
  return true;
}

function endUncollectedNotifySend(lease) {
  const id = uncollectedNotifyLeaseKey(lease);
  if (id) inFlight.delete(id);
}

module.exports = {
  STORAGE_KEY,
  uncollectedNotifyDayKey,
  uncollectedNotifyLeaseKey,
  wasUncollectedNotifySentToday,
  markUncollectedNotifySentToday,
  filterUncollectedNotifyQueue,
  beginUncollectedNotifySend,
  endUncollectedNotifySend,
};
